import React, { useState, useEffect } from 'react';
import Cookie from 'js-cookie';

import { useTranslation } from 'react-i18next';
import { BASE_URL } from '../../config/constants';
function FinalTest() {
	const { t } = useTranslation();
	const [courses, setCourses] = useState([]); // To store the list of courses
	const [courseId, setCourseId] = useState(''); // To store the selected course ID
	const [questions, setQuestions] = useState([
		{
			question: '',
			type: 'MCQ',
			options: ['', '', '', ''], // Initialize with 4 empty options
			correctAnswer: 1,
		},
	]); // To store the list of questions
	const baseUrl = BASE_URL; // Fetch courses on component mount
	useEffect(() => {
		fetchCourses();
	}, []);

	// Fetch the list of courses
	const fetchCourses = async () => {
		try {
			const response = await fetch(`${baseUrl}/api/v1/courses`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookie.get('token')}`,
				},
			});

			if (response.ok) {
				const data = await response.json();
				setCourses(data);
			} else {
				alert('Failed to fetch courses');
			}
		} catch (error) {
			console.error('Error fetching courses:', error);
		}
	};

	// Handle course selection
	const handleCourseChange = (e) => {
		setCourseId(e.target.value);
	};

	// Handle question input changes
	const handleQuestionChange = (index, e) => {
		const { name, value } = e.target;
		const updatedQuestions = [...questions];
		updatedQuestions[index][name] = value;
		setQuestions(updatedQuestions);
	};

	// Handle option input changes
	const handleOptionChange = (questionIndex, optionIndex, e) => {
		const updatedQuestions = [...questions];
		updatedQuestions[questionIndex].options[optionIndex] = e.target.value;
		setQuestions(updatedQuestions);
	};

	// Handle correct answer selection
	const handleCorrectAnswerChange = (questionIndex, e) => {
		const updatedQuestions = [...questions];
		updatedQuestions[questionIndex].correctAnswer = Number(e.target.value);
		setQuestions(updatedQuestions);
	};

	// Add a new question
	const addQuestion = () => {
		setQuestions([
			...questions,
			{
				question: '',
				type: 'MCQ',
				options: ['', '', '', ''], // Initialize with 4 empty options
				correctAnswer: 0,
			},
		]);
	};

	// Remove a question
	const removeQuestion = (index) => {
		const updatedQuestions = questions.filter((_, i) => i !== index);
		setQuestions(updatedQuestions);
	};

	// Handle form submission
	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!courseId) {
			alert('Please select a course');
			return;
		}

		const testData = {
			courseId: Number(courseId),
			questions: questions.map((q) => ({
				...q,
				correctAnswer: Number(q.correctAnswer),
			})),
		};

		try {
			const response = await fetch(`${baseUrl}/api/v1/final-test`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookie.get('token')}`,
				},
				body: JSON.stringify(testData),
			});

			if (response.ok) {
				alert('Final test created successfully');
				setCourseId('');
				setQuestions([
					{
						question: '',
						type: 'MCQ',
						options: ['', '', '', ''],
						correctAnswer: 0,
					},
				]);
			} else {
				const data = await response.json();
				alert(data.message);
			}
		} catch (error) {
			console.error('Error creating final test:', error);
		}
	};

	return (
		<div className='p-6 mt-20'>
			<h1 className='text-2xl font-bold mb-4'>{t('createFinalTest')}</h1>

			{/* Course Selection */}
			<div className='mb-6'>
				<label className='block text-sm font-medium text-gray-700'>
					{t('selectCourse')}
				</label>
				<select
					value={courseId}
					onChange={handleCourseChange}
					className='mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm text-black'>
					<option value=''> {t('selectCourse')}</option>
					{courses.map((course) => (
						<option
							key={course.id}
							value={course.id}>
							{course.name}
						</option>
					))}
				</select>
			</div>

			{/* Questions Form */}
			{questions.map((question, questionIndex) => (
				<div
					key={questionIndex}
					className='mb-6 p-4 border border-gray-300 rounded-lg'>
					<h2 className='text-lg font-semibold mb-2 text-main'>
						{t('question')} {questionIndex + 1}
					</h2>

					{/* Question Text */}
					<div className='mb-4'>
						<label className='block text-sm font-medium text-gray-700'>
							{t('question')}
						</label>
						<input
							type='text'
							name='question'
							value={question.question}
							onChange={(e) => handleQuestionChange(questionIndex, e)}
							className='mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm text-black'
							placeholder='Enter question'
						/>
					</div>

					{/* Question Type */}
					<div className='mb-4'>
						<label className='block text-sm font-medium text-gray-700'>
							{t('type')}
						</label>
						<select
							name='type'
							value={question.type}
							onChange={(e) => handleQuestionChange(questionIndex, e)}
							className='mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm text-black'>
							<option value='MCQ'>{t('mcq')}</option>
							<option value='TrueFalse'>True/False </option>
						</select>
					</div>

					{/* Options */}
					{question.type === 'MCQ' && (
						<div className='mb-4'>
							<label className='block text-sm font-medium text-gray-700'>
								{t('options')}
							</label>
							{question.options.map((option, optionIndex) => (
								<div
									key={optionIndex}
									className='mt-2'>
									<input
										type='text'
										value={option}
										onChange={(e) =>
											handleOptionChange(questionIndex, optionIndex, e)
										}
										className='block w-full p-2 border border-gray-300 rounded-md shadow-sm text-black'
										placeholder={`Option ${optionIndex + 1}`}
									/>
								</div>
							))}
						</div>
					)}

					{/* Correct Answer */}
					<div className='mb-4'>
						<label className='block text-sm font-medium text-gray-700'>
							{t('correctAnswer')}
						</label>
						{question.type === 'MCQ' ? (
							<select
								value={question.correctAnswer}
								onChange={(e) => handleCorrectAnswerChange(questionIndex, e)}
								className='mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm text-black'>
								{question.options.map((_, index) => (
									<option
										key={index}
										value={index + 1}>
										Option {index + 1}
									</option>
								))}
							</select>
						) : (
							<select
								value={question.correctAnswer}
								onChange={(e) => handleCorrectAnswerChange(questionIndex, e)}
								className='mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm text-black'>
								<option value={0}>False</option>
								<option value={1}>True</option>
							</select>
						)}
					</div>

					{/* Remove Question Button */}
					<button
						type='button'
						onClick={() => removeQuestion(questionIndex)}
						className='bg-red-500 text-white px-4 py-2 rounded-md'>
						{t('removeQuestion')}
					</button>
				</div>
			))}

			{/* Add Question Button */}
			<button
				type='button'
				onClick={addQuestion}
				className='bg-blue-500 text-white px-4 py-2 rounded-md mb-6 mr-3'>
				{t('addMoreQuestion')}
			</button>

			{/* Submit Button */}
			<button
				type='button'
				onClick={handleSubmit}
				className='bg-green-500 text-white px-4 py-2 rounded-md'>
				{t('createFinalTest')}
			</button>
		</div>
	);
}

export default FinalTest;
